(function () {
  'use strict';

  function parseJsonScript(id) {
    var el = document.getElementById(id);

    if (!el) {
      return null;
    }

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.warn('OW PC30: invalid JSON in', id, error);
      return null;
    }
  }

  function normalizeMoneyValue(value) {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    var normalized_value = Number(value);

    if (Number.isNaN(normalized_value)) {
      return null;
    }

    return normalized_value;
  }

  function formatMoney(value, money_format) {
    var normalized_value = normalizeMoneyValue(value);

    if (normalized_value === null) {
      return '';
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(normalized_value, money_format);
    }

    return (normalized_value / 100).toFixed(2) + ' €';
  }

  function getFirstProductSection() {
    return document.querySelector('[data-section-type="product"]');
  }

  function getSectionId(section) {
    if (!section) {
      return null;
    }

    return section.getAttribute('data-section-id');
  }

  function getProductData(section_id) {
    if (!section_id) {
      return null;
    }

    return parseJsonScript('ProductJson-' + section_id);
  }

  function getPc30Data(section_id) {
    if (!section_id) {
      return null;
    }

    return parseJsonScript('Pc30Json-' + section_id);
  }

  function getMasterVariantId(section) {
    if (!section) {
      return null;
    }

    var master_select = section.querySelector('select[name="id"]');

    if (!master_select || !master_select.value) {
      return null;
    }

    return String(master_select.value);
  }

  function getOptionPositionFromIndex(index_value) {
    if (!index_value) {
      return null;
    }

    var match = String(index_value).match(/option(\d+)/i);

    if (!match) {
      return null;
    }

    return Number(match[1]);
  }

  function getClosestOptionContainer(element) {
    if (!element) {
      return null;
    }

    return (
      element.closest('.buy-me-variants') ||
      element.closest('form') ||
      element.closest('[data-product-form]') ||
      element.closest('.product-form') ||
      element.closest('[data-section-type="product"]') ||
      document
    );
  }

  function collectSelectedOptionsFromContainer(container) {
    var selected_options = [];

    if (!container || !container.querySelectorAll) {
      return selected_options;
    }

    var selectors = container.querySelectorAll('.single-option-selector');

    selectors.forEach(function (select) {
      var position = getOptionPositionFromIndex(select.getAttribute('data-index'));

      if (!position) {
        return;
      }

      selected_options[position - 1] = select.value;
    });

    return selected_options;
  }

  function mergeSelectedOptions(primary_options, fallback_options) {
    var merged = [];
    var max_length = Math.max(primary_options.length, fallback_options.length);

    for (var i = 0; i < max_length; i += 1) {
      if (
        primary_options[i] !== undefined &&
        primary_options[i] !== null &&
        primary_options[i] !== ''
      ) {
        merged[i] = primary_options[i];
      } else {
        merged[i] = fallback_options[i];
      }
    }

    return merged;
  }

  function collectSelectedOptions(changed_element, section) {
    var primary_container = getClosestOptionContainer(changed_element);
    var primary_options = collectSelectedOptionsFromContainer(primary_container);
    var fallback_options = collectSelectedOptionsFromContainer(section || document);
    var selected_options = mergeSelectedOptions(primary_options, fallback_options);

    if (changed_element) {
      var changed_position = getOptionPositionFromIndex(changed_element.getAttribute('data-index'));

      if (changed_position) {
        selected_options[changed_position - 1] = changed_element.value;
      }
    }

    return selected_options;
  }

  function variantMatchesSelectedOptions(variant, selected_options) {
    if (!variant || !variant.options) {
      return false;
    }

    for (var i = 0; i < selected_options.length; i += 1) {
      var selected_value = selected_options[i];

      if (
        selected_value !== undefined &&
        selected_value !== null &&
        selected_value !== '' &&
        variant.options[i] !== selected_value
      ) {
        return false;
      }
    }

    return true;
  }

  function findVariantByOptions(product_data, selected_options) {
    if (!product_data || !product_data.variants || !selected_options.length) {
      return null;
    }

    for (var i = 0; i < product_data.variants.length; i += 1) {
      var variant = product_data.variants[i];

      if (variantMatchesSelectedOptions(variant, selected_options)) {
        return variant;
      }
    }

    return null;
  }

  function findVariantById(product_data, variant_id) {
    if (!product_data || !product_data.variants || !variant_id) {
      return null;
    }

    for (var i = 0; i < product_data.variants.length; i += 1) {
      if (String(product_data.variants[i].id) === String(variant_id)) {
        return product_data.variants[i];
      }
    }

    return null;
  }

  function resolveCurrentVariant(section, changed_element) {
    var section_id = getSectionId(section);
    var product_data = getProductData(section_id);

    if (!product_data) {
      return null;
    }

    var selected_options = collectSelectedOptions(changed_element, section);
    var matched_variant = findVariantByOptions(product_data, selected_options);

    if (matched_variant) {
      return matched_variant;
    }

    var master_variant_id = getMasterVariantId(section);
    var master_variant = findVariantById(product_data, master_variant_id);

    if (master_variant) {
      return master_variant;
    }

    return null;
  }

  function updatePc30(changed_element) {
    var section = getFirstProductSection();

    if (!section) {
      return;
    }

    var section_id = getSectionId(section);
    var pc30_data = getPc30Data(section_id);
    var wrapper = section.querySelector('[data-pc30-wrapper]');
    var value_el = section.querySelector('[data-pc30-value]');

    if (!pc30_data || !wrapper || !value_el) {
      return;
    }

    var pc30_value = null;

    if (pc30_data.productHasOnlyDefaultVariant) {
      pc30_value = pc30_data.productPc30;
    } else {
      var current_variant = resolveCurrentVariant(section, changed_element);

      if (
        current_variant &&
        pc30_data.variants &&
        Object.prototype.hasOwnProperty.call(pc30_data.variants, String(current_variant.id))
      ) {
        pc30_value = pc30_data.variants[String(current_variant.id)];
      }
    }

    if (pc30_value === null || pc30_value === undefined || pc30_value === '') {
      wrapper.hidden = true;
      value_el.textContent = '';
      return;
    }

    wrapper.hidden = false;
    value_el.innerHTML = 'PC30: ' + formatMoney(pc30_value, pc30_data.moneyFormat);
  }

  function bindEvents() {
    if (document.documentElement.dataset.owPc30Bound === 'true') {
      return;
    }

    document.documentElement.dataset.owPc30Bound = 'true';

    document.addEventListener('change', function (event) {
      var target = event.target;

      if (!target) {
        return;
      }

      if (
        target.matches('.single-option-selector') ||
        target.matches('[class*="single-option-selector-"]') ||
        target.matches('select[name="id"]')
      ) {
        window.requestAnimationFrame(function () {
          updatePc30(target);
        });

        window.setTimeout(function () {
          updatePc30(target);
        }, 50);

        window.setTimeout(function () {
          updatePc30(target);
        }, 150);

        window.setTimeout(function () {
          updatePc30(target);
        }, 300);
      }
    });

    document.addEventListener('input', function (event) {
      var target = event.target;

      if (!target) {
        return;
      }

      if (
        target.matches('.single-option-selector') ||
        target.matches('[class*="single-option-selector-"]')
      ) {
        window.requestAnimationFrame(function () {
          updatePc30(target);
        });
      }
    });

    document.addEventListener('click', function () {
      window.setTimeout(function () {
        updatePc30(null);
      }, 50);
    });
  }

  function init() {
    bindEvents();
    updatePc30(null);
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function () {
    init();
  });

  document.addEventListener('shopify:section:reorder', function () {
    init();
  });
})();